import {
  getActionDescription,
  getApiActions,
} from '@binotel-frontend/bnt-common-components';
import {IListSubject} from '@entities/subject';
import {createAction, props} from '@ngrx/store';

const desc = getActionDescription('Favorites');

export namespace FavoritesActions {
  export const getFavorites = getApiActions(
    desc('Get favorites'),
    props<{payload: IListSubject[]}>()
  );

  export const clearFavorites = createAction(desc('Clear favorites'));
}
